import React from 'react'
import { useTranslation } from 'react-i18next'
import IconTime from '../../../../svg/iconTime.svg'
import { calculateFormattedExpirationDate } from '../../utils'

export const DowngradeTo = ({ subscription }) => {
    const { t } = useTranslation()
    const { productForDowngrade, expirationDate } = subscription
    const downgradeTo = productForDowngrade.name.split(' ')[0]
    const formattedExpirationDate = calculateFormattedExpirationDate(expirationDate)
    return (
        <div className="subscriptions__state__row">
            <div className="subscriptions__state__item-mobile">
                <span className="subscriptions__state__item-title">{t('Your next plan:')} </span>
                <span className="subscriptions__state__item-active-value">{downgradeTo}</span>
            </div>
            <div className="subscriptions__state__item-icon-value">
                <img className="payment" src={IconTime} alt="" />
                <span className="subscriptions__state__item-value">
                    {t('Starts on')} {formattedExpirationDate}
                </span>
            </div>
        </div>
    )
}
